import React, { useEffect, useRef, useState } from "react";
import CryptoJS from "crypto-js";
// Formik Validation

import { useNavigate, useSearchParams } from "react-router-dom";

import { Row, Col, Form, Label, Input, Button } from "reactstrap";

// import images
import verificationImg from "../../assets/images/5024147-Photoroom.png";
import "assets/scss/custom/pages/_signup.scss";
import { callResendOTP, callVerifySignUp } from "http/auth/signup";
import ToastDialog from "components/Common/ToastDialog";

const CustomerSignUpVerify = () => {
  const [num, setNum] = useState(0);
  const [toastInfo, setToastInfo] = useState({ showToast: false });
  const [searchParams] = useSearchParams();
  const [otp, setOtp] = useState("");

  let intervalRef = useRef();

  const decreaseNum = () => {
    setNum((prev) => prev - 1);
  };
  const navigate = useNavigate();
  //meta title
  document.title = "Account Verification | FundLync";

  // const otpValue = []

  useEffect(() => {
    if (num == 0) {
      clearInterval(intervalRef.current);
    }
  }, [num]);

  const getParamsValue = (key) => {
    return searchParams.get(key) || "";
  };

  const handleChange = (index, value) => {
    const inputValue = value.target.value;
    const updatedOtp = otp ? otp.split('') : Array(4).fill('');
  
    // Update the OTP array with the entered value
    updatedOtp[index - 1] = inputValue;
  
    setOtp(updatedOtp.join(''));
  
    if (inputValue === '' && index > 1) {
      // If the current input is empty, move the focus to the previous input field
      const prevInput = document.getElementById(`digit${index - 1}-input`);
      if (prevInput) {
        prevInput.focus();
      }
    } else if (inputValue !== '' && index < 4) {
      // If a character is entered and it's not the last field, move the focus to the next input field
      const nextInput = document.getElementById(`digit${index + 1}-input`);
      if (nextInput) {
        nextInput.focus();
      }
    }
  };
  

  const startResendInterval = (duration) => {
    setNum(duration);
    intervalRef.current = setInterval(decreaseNum, 1000);
  };

  const submitVerifyOTP = () => {
    let otpValue = otp.split("");
    const otpFilter = otpValue.filter((o) => o.length > 0);
    if (otpFilter.length != 4) {
      setToastInfo({
        message: "Enter valid OTP",
        showToast: true,
        role: "error",
      });
      return;
    }

    const entityId = getParamsValue("entity");
    const email = getParamsValue("email");
    console.log(otpValue.join(""), 'otp')
    const postParams = {
      entityId: entityId,
      email,
      otp: otpValue.join(""),
    };
    callVerifySignUp(postParams)
      .then((result) => {
        if (result.status) {
          const { data, tokens, permissions } = result;

          const passphrase = process.env.REACT_APP_KEY;
          const encryptedUser = CryptoJS.AES.encrypt(
            JSON.stringify(data),
            passphrase
          ).toString();

          localStorage.setItem("user", encryptedUser)
          localStorage.setItem("tokens", JSON.stringify(tokens));
          localStorage.setItem("permissions", JSON.stringify(permissions));
          const encryptedId = btoa(result.data.entityId.toString());
          navigate(
            `/customer/entity-dashboard?id=${encodeURIComponent(encryptedId)}`
          );
        } else {
          const { message } = result;
          setToastInfo({ message: message, showToast: true, role: "error" });
        }
      })
      .catch((e) => {})
      .finally((f) => {});
  };

  const reSendOTP = () => {
    const entityId = getParamsValue("entity");
    const email = getParamsValue("email");

    const postParams = {
      entityId: entityId,
      email,
    };
    callResendOTP(postParams)
      .then((result) => {
        if (result.status) {
          setToastInfo({
            message: "OTP sent successfully",
            showToast: true,
            role: "success",
          });
          startResendInterval(120);
        } else {
          const { message } = result;
          setToastInfo({ message: message, showToast: true, role: "error" });
        }
      })
      .catch((e) => {})
      .finally((f) => {});
  };

  const timerStr = () => {
    const seconds = Math.floor(num % 60);
    const minutes = Math.floor((num / 60) % 60);

    const minStr = minutes < 10 ? `0${minutes}`.slice(-2) : minutes
    const secStr = seconds < 10 ? `0${seconds}`.slice(-2) : seconds
    return  `${minStr}:${secStr}`;
  };

  return (
    <React.Fragment>
      <div className="account-pages account-pages-bg">
        <Row className="justify-content-center w-100 h-100vh">
          <Col xl={8} className="d-none d-lg-block">
            <div className="left-section h-100">
              <div className="d-flex justify-content-center w-100 h-100 align-items-center">
                <img
                  src={verificationImg}
                  alt=""
                  className="img-fluid verification-img"
                />
              </div>
            </div>
          </Col>
          <Col
            md={11}
            lg={11}
            xl={4}
            className="form-layout-section content-center"
          >
            <div className="p-2">
              <Row className="justify-content-center ">
                <Col md={12} lg={9} xl={9}>
                  <div className="p-2">
                    <div className="text-center">
                      <div className="avatar-md mx-auto">
                        <div className="avatar-title rounded-circle bg-light">
                          <i className="bx bxs-envelope h1 mb-0 text-primary"></i>
                        </div>
                      </div>
                      <div className="p-2 mt-4">
                        <h4>Verify your email</h4>
                        <p className="mb-5">
                          Please enter the 4 digit code sent to{" "}
                          <span className="fw-semibold">
                            {getParamsValue("email")}
                          </span>
                        </p>

                        <Form>
                          <Row>
                            <Col className="col-3">
                              <div className="mb-3">
                                <Label
                                  htmlFor="digit1-input"
                                  className="visually-hidden"
                                >
                                  Dight 1
                                </Label>
                                <Input
                                  style={{minWidth: '44.8px'}}
                                  type="text"
                                  className="form-control form-control-lg text-center two-step"
                                  maxLength="1"
                                  tabIndex="1"
                                  id="digit1-input"
                                  onChange={(e) => handleChange(1, e)}
                                />
                              </div>
                            </Col>

                            <Col className="col-3">
                              <div className="mb-3">
                                <Label
                                  htmlFor="digit2-input"
                                  className="visually-hidden"
                                >
                                  Dight 2
                                </Label>
                                <Input
                                style={{minWidth: '44.8px'}}
                                  type="text"
                                  className="form-control form-control-lg text-center two-step"
                                  maxLength="1"
                                  tabIndex="2"
                                  id="digit2-input"
                                  onChange={(e) => handleChange(2, e)}
                                />
                              </div>
                            </Col>

                            <Col className="col-3">
                              <div className="mb-3">
                                <Label
                                  htmlFor="digit3-input"
                                  className="visually-hidden"
                                >
                                  Dight 3
                                </Label>
                                <Input
                                style={{minWidth: '44.8px'}}
                                  type="text"
                                  className="form-control form-control-lg text-center two-step"
                                  maxLength="1"
                                  tabIndex="3"
                                  id="digit3-input"
                                  onChange={(e) => handleChange(3, e)}
                                />
                              </div>
                            </Col>

                            <Col className="col-3">
                              <div className="mb-3">
                                <Label
                                  htmlFor="digit4-input"
                                  className="visually-hidden"
                                >
                                  Dight 4
                                </Label>
                                <Input
                                style={{minWidth: '44.8px'}}
                                  type="text"
                                  className="form-control form-control-lg text-center two-step"
                                  maxLength="1"
                                  tabIndex="4"
                                  id="digit4-input"
                                  onChange={(e) => handleChange(4, e)}
                                />
                              </div>
                            </Col>
                          </Row>
                        </Form>

                        <div className="mt-4">
                          <Button
                            color="primary"
                            type="submit"
                            onClick={() => submitVerifyOTP()}
                          >
                            <span>Confirm</span>
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-2 text-center">
                    {num == 0 && (
                      <p>
                        Didn&apos;t receive a code ?{" "}
                        <a
                          href="#"
                          className="fw-medium text-primary"
                          onClick={() => reSendOTP()}
                        >
                          {" "}
                          Resend{" "}
                        </a>{" "}
                      </p>
                    )}
                    {num > 0 && (
                      <p>
                        Resend OTP in{" "}
                        <a href="#" className="fw-medium text-primary">
                          {" "}
                          {timerStr()}{" "}
                        </a>{" "}
                      </p>
                    )}
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
      <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      ></ToastDialog>
    </React.Fragment>
  );
};

export default CustomerSignUpVerify;
